const AlarmIcon = ({ strokeColor = '#808080' }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 795.1 795.1"
  >
    <g id="Circles">
      <circle
        id="Grey_Bkg"
        data-name="Grey Bkg"
        fill="#4d4d4d"
        cx="397.55"
        cy="397.55"
        r="388.66"
      />
      <circle
        id="Green"
        fill="none"
        stroke={strokeColor}
        strokeWidth="50"
        strokeMiterlimit="10"
        cx="397.55"
        cy="397.55"
        r="372.55"
      />
      <circle
        id="White_Inner"
        data-name="White Inner"
        fill="none"
        stroke="#fff"
        strokeWidth="20"
        strokeMiterlimit="10"
        cx="397.55"
        cy="397.55"
        r="343.4"
      />
    </g>
    <g id="Shapes">
      <g id="Alarm">
        <path
          fill="#fbfbfb"
          d="M263.04,284.54c29.55-25.47,58.51-50.53,87.44-75.63,7.63-6.62,15.09-13.44,22.75-20.03,7-6.03,14.85-6.92,23.13-2.93,8.02,3.87,12.96,9.44,12.97,19.27.15,127,.48,253.99.93,380.98.04,10.94-5.7,17.78-14.2,22.94-8.17,4.96-15.86,1.59-22.13-3.61-17.82-14.79-35.1-30.23-52.71-45.28-19.86-16.97-39.77-33.89-59.9-50.54-2.21-1.83-5.95-2.5-8.98-2.5-14.27-.03-28.54.56-42.81.57-24.32.03-36.88-10.24-37.99-34.59-1.66-36.18-1.56-72.47-1.77-108.71-.09-15.12.27-30.32,1.68-45.37,1.78-19.04,14.37-30.17,33.71-30.85,15.74-.56,31.5-.44,47.24-.93,3.37-.11,6.7-1.57,10.65-2.79M224.09,318.15c-3.57.02-7.14-.04-10.71.07-11.88.35-12.94,1.41-13.42,13.25-.06,1.49-.02,2.97-.02,4.46,0,43.42,0,86.84,0,130.26v9.34c21.2,0,41.61.31,62.01-.17,6.96-.16,12.51,1.09,17.8,5.83,19.02,17.05,38.26,33.85,57.54,50.62,13.07,11.37,26.34,22.52,40.5,34.6V227.41c-5.64,4.37-10.47,7.76-14.9,11.61-28.68,24.95-57.21,50.09-86.01,74.89-2.82,2.43-7.18,4.14-10.89,4.26-13.37.44-26.76.07-41.91-.03Z"
        />
        <path
          fill="#fcfcfc"
          d="M606.72,491.48c-13.42,28.76-32.6,52.27-55.75,72.71-7.58,6.7-15.95,6.48-22.83-.29-7.72-7.6-7-13.66.94-22.06,12.15-12.85,25.49-25.11,35.09-39.74,25.61-39.03,32.82-82.7,29.08-128.9-2.93-36.18-15.29-68.35-37.49-96.69-7.1-9.07-15.84-16.88-24.01-25.09-7.6-7.63-8.56-16.44-2.22-23.56,5.6-6.29,17.47-6.34,24.49.21,34.24,31.9,58.45,69.47,66.39,116.45,7.88,46.62,7.5,92.57-9.74,137.36-1.16,3.02-2.46,5.98-3.95,9.6h0Z"
        />
        <path
          fill="#fcfcfc"
          d="M512.96,427.86c12.5-48.84-2.09-89.16-35.76-123.85-9.39-9.67-10.27-16.72-2.53-24.28,6-5.86,14.33-6.02,20.7-.4,66.82,58.99,71.17,158.42,9.76,222.5-3.5,3.65-6.71,7.57-10.28,11.14-6.58,6.58-14.25,6.5-21.21.01-7.34-6.84-8.12-13.8-.68-20.69,13.21-12.23,24.46-25.79,31.92-42.19,3.15-6.93,5.25-14.35,8.08-22.23h0Z"
        />
      </g>
    </g>
  </svg>
);

export default AlarmIcon;
